import React, { PropTypes } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import Loading  from 'components/helpers/loading';
import JournalEntry from './journalEntry';
import StaticMap from 'components/googleMap/staticMap';

class Journal extends React.Component {

    constructor(props) {
        super(props);
        var self = this;

        self.props.getAllCheckins();

        self.state = {
            isLoading: true,
            isSingleView: !!self.props.params.id
        };
    }

    toRad = (x) => {
        return x * Math.PI / 180;
    }

    componentWillReceiveProps(nextProps) {
        var self = this,
            isSingleViewLoaded = (self.state.isSingleView && nextProps && nextProps.checkins != null && nextProps.checkins.length === 1),
            isMultiViewLoaded = (!self.state.isSingleView && nextProps && nextProps.checkins != null);

        if (self.state.isLoading && (isSingleViewLoaded || isMultiViewLoaded)) {
            self.setState({
                isLoading: false
            })
        }
    }

    render() {
        var self = this,
            title,
            actions,
            checkinComponents,
            publishedCheckins,
            journalClass,
            mostRecentCheckin,
            sidebar;

        if (self.state.isLoading) {
            return <Loading />;
        }

        if (self.state.isSingleView && self.props.checkins && self.props.checkins.length === 1) {
            title = 'Walkabout: ' + self.props.checkins[0].summary;
        }
        else {
            title = 'Walkabout: Journal';
        }

        publishedCheckins = _.filter(self.props.checkins, checkin => !checkin.isDraft);

        checkinComponents = _.map(self.props.currentUser ? self.props.checkins : publishedCheckins, (checkin) => {
            return (
                <JournalEntry key={ checkin.id }
                              detail={ checkin }
                              currentUser={ self.props.currentUser }
                              onDelete={ self.props.deleteCheckin } />
            );
        });

        if (!checkinComponents || !checkinComponents.length) {
            return (
                <div className="container jumbotron-container vertical-center">
                    <Helmet title={ title } />
                    <div className="card horizontal-center" style={ { maxWidth: '600px' } }>
                        <div className="card-block">
                            <p className="card-text text-muted-inverse text-xs-center">&ndash; No journal entries yet, but please come back soon! &ndash;</p>

                            <p className="card-text text-muted-inverse text-xs-center">In the meantime, feel free to check out <Link to="/itinerary" className="inverse-link">my master plan</Link>.</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (publishedCheckins && publishedCheckins.length) {
            mostRecentCheckin = (
                <div className="row journal-sidebar-row">
                    <h4 className="text-inverse">Where am I now?</h4>
                    <hr />
                    <StaticMap point={ publishedCheckins[0].place } />
                </div>
            );
        }

        if (!self.state.isSingleView) {
            sidebar = (
                <div className="hidden-md-down col-lg-4 journal-sidebar">
                    {
                        mostRecentCheckin
                    }
                    <div className="row journal-sidebar-row">
                        <h4 className="text-inverse">Why I'm Travelling</h4>
                        <hr />
                        <p className="text-muted-inverse">
                            I've always wanted to visit Australia and New Zealand. I mean come on, they have some of the most awe inspiring views our planet has to offer. Side bonus though: it is warm there in February and I'm tired of being cold on my birthday.
                        </p>
                    </div>
                </div>
            );
        }

        journalClass = classNames('journal col-xs-12', {
            'col-lg-8': !self.state.isSingleView
        });

        return (
            <div className="page-container page-container-responsive">
                <Helmet title={ title } />
                <div className="page-content page-content-transparent">
                    <div className={ journalClass }>
                        { checkinComponents }
                    </div>
                    {
                        sidebar
                    }
                </div>
            </div>
        );
    }
};

export default Journal;


// WEBPACK FOOTER //
// ./src/app/components/journal/journal.jsx